import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { useIntl } from "react-intl";

var ForgottenPassword = function ForgottenPassword(_ref) {
  var onClick = _ref.onClick;
  var intl = useIntl();
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login__content__password-reminder"
  }, React.createElement("span", {
    className: "u-link",
    onClick: onClick
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Forgot your password ?",
    "id": "components.OverlayManager.Login.ForgottenPassword.3389837852"
  }, "id", "components.OverlayManager.Login.ForgottenPassword.3389837852")))));
};

export default ForgottenPassword;